"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapPlaidAccountSubtypeToDBSubtype = exports.mapPlaidAccountsToAccountType = exports.getPVSum = exports.getPVValue = exports.calculateNetIncome = exports.getGrossMonthlyIncome = exports.convertGrossValueToMonthlyGross = exports.formatDeductionsForTaxCalculation = exports.getDeductionIndexFromIncome = exports.getAccountIndexById = exports.updateIncomeBoolean = exports.updateAccountBoolean = exports.getDeductionFromIncome = exports.getTotalMonthlyExpenses = exports.getIncomeById = exports.getExpenseById = exports.getAccountById = void 0;
var const_1 = require("./const");
function getAccountById(user, accId) {
    var account = user.accounts.find(function (x) { return x.id === accId; });
    if (!account) {
        throw new Error("User does not have an account with id ".concat(accId));
    }
    return account;
}
exports.getAccountById = getAccountById;
function getExpenseById(user, expenseId) {
    var expense = user.expenses.find(function (exp) { return exp.id === expenseId; });
    if (!expense) {
        throw new Error("User does not have an expense with id ".concat(expenseId));
    }
    return expense;
}
exports.getExpenseById = getExpenseById;
// export function getExpenseFutureValueByIndex(
//   user: UserModel,
//   expenseId: any,
//   futureValueIndex: number
// ) {
//   const expense = getExpenseById(user, expenseId);
//   return expense.amount.future[futureValueIndex];
// }
function getIncomeById(user, incomeId) {
    var income = user.incomes.find(function (x) { return x.id === incomeId; });
    if (!income) {
        throw new Error("User does not have an income with id ".concat(incomeId));
    }
    return income;
}
exports.getIncomeById = getIncomeById;
function getTotalMonthlyExpenses(user) {
    return user.expenses.reduce(function (prev, acc) {
        return prev + acc.amount.presentValue;
    }, 0);
}
exports.getTotalMonthlyExpenses = getTotalMonthlyExpenses;
function getDeductionFromIncome(income, accountId) {
    var _a;
    var deduction = (_a = income.deductions) === null || _a === void 0 ? void 0 : _a.find(function (ded) { return ded.account_id === accountId; });
    if (!deduction) {
        throw new Error("There is not a deduction with id ".concat(accountId, " on this income"));
    }
    return deduction;
}
exports.getDeductionFromIncome = getDeductionFromIncome;
function updateAccountBoolean(user, account) {
    return user.accounts.findIndex(function (acc) { return acc.id === account.id; }) >= 0;
}
exports.updateAccountBoolean = updateAccountBoolean;
function updateIncomeBoolean(user, income) {
    return user.incomes.findIndex(function (inc) { return inc.id === income.id; }) >= 0;
}
exports.updateIncomeBoolean = updateIncomeBoolean;
function getAccountIndexById(user, account) {
    var accountIndex = user.accounts.findIndex(function (acc) { return acc.id === account.id; });
    if (accountIndex < 0) {
        throw new Error("There is not an account with id ".concat(account.id, "."));
    }
    return accountIndex;
}
exports.getAccountIndexById = getAccountIndexById;
function getDeductionIndexFromIncome(income, accountId) {
    var _a;
    var deductionIndex = (_a = income.deductions) === null || _a === void 0 ? void 0 : _a.findIndex(function (ded) { return ded.account_id === accountId; });
    if (deductionIndex === undefined || deductionIndex < 0) {
        throw new Error("There is not a deduction with id of ".concat(accountId, " attached to this income!!!!"));
    }
    return deductionIndex;
}
exports.getDeductionIndexFromIncome = getDeductionIndexFromIncome;
// export function getIncomeAfterTaxCalculation(income: IncomeModel) {
//   const adjustedDeductions = formatDeductionsForNetWorthCalculation(
//     income?.deductions || []
//   );
//   const incomeBreakdown = calculateUSATaxes({
//     filingStatus: income.filing_status,
//     grossSalary: income.gross_value,
//     deductions: adjustedDeductions,
//     is1099: income.type === "1099",
//     state: income.us_tax_state,
//   });
//   const newInc: IncomeModel = {
//     ...income,
//     tax: {
//       federalTaxes: incomeBreakdown.federalTaxes / 12,
//       medicare: incomeBreakdown.medicare / 12,
//       socialSecurity: incomeBreakdown.socialSecurity / 12,
//       stateTaxes: incomeBreakdown.stateTaxes / 12,
//     },
//     net_value: incomeBreakdown.netIncome / 12,
//   };
//   return newInc;
// }
// When someone changes a deduction account contribution income, then the old income needs to be updated without that deduction
// export function getNewIncomeAfterDeductionAccountIncomeContributionIDHasBeenRemovedOrChanged(
//   user: UserModel,
//   deductionAcc: AccountModel
// ) {
//   // Find all incomes that have the deduction account in their deductions
//   const incomesWithDeduction = user.incomes.filter(
//     (inc) =>
//       inc.deductions &&
//       inc.deductions.findIndex((ded) => ded.account_id === deductionAcc.id) >= 0
//   );
//   // Now grab the income that needs the deduction account removed
//   const incomeToBeChanged = incomesWithDeduction.find(
//     (inc) => inc.id !== deductionAcc.contribution_income_id
//   );
//   // Now remove the deduction account and run the salaryCalc model
//   const deductionAccIndex = incomeToBeChanged?.deductions?.findIndex(
//     (ded) => ded.account_id === deductionAcc.id
//   );
//   if (!deductionAccIndex || !incomeToBeChanged) {
//     throw new Error(
//       `There is not a deduction account with id ${deductionAcc.id} attached to this income ${incomeToBeChanged?.id}`
//     );
//   }
//   incomeToBeChanged?.deductions?.splice(deductionAccIndex, 1);
//   const newInc = getIncomeAfterTaxCalculation(incomeToBeChanged);
//   return newInc;
// }
function formatDeductionsForTaxCalculation(user, 
// Other incomes is used for calculating tax amounts before the income is saved to user
incomes) {
    var allDeductions = [];
    for (var _i = 0, incomes_1 = incomes; _i < incomes_1.length; _i++) {
        var inc = incomes_1[_i];
        if (inc.deductions) {
            for (var _a = 0, _b = inc.deductions; _a < _b.length; _a++) {
                var ded = _b[_a];
                var dedAccount = getAccountById(user, ded.account_id);
                allDeductions.push(dedAccount);
            }
        }
    }
    var formattedDeductions = allDeductions.map(function (ded) {
        var _a, _b, _c;
        return ({
            annualValue: (((_a = ded.monthly_projected_contribution) === null || _a === void 0 ? void 0 : _a.presentValue) || 0) * 12,
            preTax: user.tax_info.region === "US"
                ? !!((_b = const_1.deduction_accounts_USA.find(function (d) { return d.value === ded.sub_type; })) === null || _b === void 0 ? void 0 : _b.preTax)
                : !!((_c = const_1.deductions_accounts_UK.find(function (d) { return d.value === ded.sub_type; })) === null || _c === void 0 ? void 0 : _c.preTax),
        });
    });
    console.log("formatted deductions -->", formattedDeductions);
    return formattedDeductions;
}
exports.formatDeductionsForTaxCalculation = formatDeductionsForTaxCalculation;
function convertGrossValueToMonthlyGross(value, type) {
    console.log("CHAD", type);
    switch (type) {
        case "1099":
            return value / 12;
        case "W2":
            return value / 12;
        case "Other":
            return value;
    }
    console.warn("Unhandled income type: " + type);
    return value;
}
exports.convertGrossValueToMonthlyGross = convertGrossValueToMonthlyGross;
function getGrossMonthlyIncome(income) {
    return convertGrossValueToMonthlyGross(income.value.presentValue, income.type);
}
exports.getGrossMonthlyIncome = getGrossMonthlyIncome;
function calculateNetIncome(user, incomes) {
    var _a;
    // Start from total gross monthly income
    var grossMonthlyIncome = incomes.reduce(function (prev, inc) {
        return prev + getGrossMonthlyIncome(inc);
    }, 0);
    var taxes = user.tax_info;
    if (taxes.region === "US") {
        grossMonthlyIncome -= taxes.federalTaxes || 0;
        grossMonthlyIncome -= taxes.medicare || 0;
        grossMonthlyIncome -= taxes.socialSecurity || 0;
        grossMonthlyIncome -= taxes.stateTaxes || 0;
    }
    else {
        grossMonthlyIncome -= taxes.totalTaxes || 0;
    }
    for (var _i = 0, incomes_2 = incomes; _i < incomes_2.length; _i++) {
        var inc = incomes_2[_i];
        if (inc.deductions) {
            for (var _b = 0, _c = inc.deductions; _b < _c.length; _b++) {
                var d = _c[_b];
                var dedAccount = getAccountById(user, d.account_id);
                grossMonthlyIncome -=
                    ((_a = dedAccount.monthly_projected_contribution) === null || _a === void 0 ? void 0 : _a.presentValue) || 0;
            }
        }
    }
    var netIncome = grossMonthlyIncome;
    return netIncome;
}
exports.calculateNetIncome = calculateNetIncome;
function getPVValue(pv, date) {
    var _a;
    if (!date) {
        return pv.presentValue;
    }
    if (date === "at-fi") {
        return pv.valueAtFI || pv.presentValue;
    }
    if (pv.endDate && date > pv.endDate) {
        return 0;
    }
    if (pv.startDate && date < pv.startDate) {
        return 0;
    }
    var value = pv.presentValue;
    var futureIncome = (_a = pv.future) === null || _a === void 0 ? void 0 : _a.find(function (f) {
        var changeStartDate = f.startDate;
        return (date >= changeStartDate &&
            (!f.endDate || date <= f.endDate));
    });
    if (futureIncome) {
        value = futureIncome.value;
    }
    return value;
}
exports.getPVValue = getPVValue;
function getPVSum(pvs, date) {
    return pvs.reduce(function (prev, x) {
        return prev + getPVValue(x, date);
    }, 0);
}
exports.getPVSum = getPVSum;
function mapPlaidAccountsToAccountType(plaid_type) {
    switch (plaid_type) {
        case "credit":
        case "loan":
            return "DEBT";
        case "depository":
        case "investment":
            return "SAVINGS";
        case "other":
            return "OTHER";
    }
}
exports.mapPlaidAccountsToAccountType = mapPlaidAccountsToAccountType;
function mapPlaidAccountSubtypeToDBSubtype(plaid_subtype) {
    var subtype = const_1.plaidAccountSubtypes.find(function (plaid_st) { return plaid_st.plaid_subtype === plaid_subtype; });
    if (!subtype) {
        throw new Error("There is no plaid subtype of ".concat(plaid_subtype));
    }
    return subtype.db_value;
}
exports.mapPlaidAccountSubtypeToDBSubtype = mapPlaidAccountSubtypeToDBSubtype;
